import { z } from "zod";
/**
 * An organisation admin's request, made through the Twin, to replace one existing curated view's SQL. It becomes a
 * convergence proposal that an admin approves; the existing apply job then runs the curated-view gate and the DDL.
 */
export const proposeCuratedViewCommandInputSchema = z.object({
    viewName: z.string().regex(/^[a-z_][a-z0-9_]{0,62}$/u, "Use the curated view's own lower-case name."),
    sql: z.string().trim().min(1).max(80_000),
    title: z.string().trim().min(1).max(240),
    rationale: z.string().trim().min(1).max(4000),
}).strict();
export const curatedViewProposalResultSchema = z.object({
    proposalId: z.string().min(1),
    status: z.string().min(1),
    viewName: z.string().min(1),
    title: z.string().min(1),
}).strict();
